<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class='view-container text-center' style="min-width: 95%;">
    <div class='text-right cursor-pointer'>
      <b-button variant='link' @click='back'>
        <font-awesome-icon icon='times' />
      </b-button>
    </div>

    <h1 class="mb-5">Estratto conto</h1>

    <loading-spinner v-if='loading' />
    <div v-else-if='$store.getters.isAuthenticated && $route.query.estrattoConto == 1'>
      <b-alert v-if="this.ecAnaliticoItems.length == 0" show variant="info" class="my-4">
        Non ci sono dati da visualizzare.
      </b-alert>
      <span v-else>
        <div class="row">
          <h4 class='ml-4' style='float: left;'>Matricola: {{ $route.query.matricola }} - Elenco movimenti analitico</h4>
        </div>
        <div class='row justify-content-between mx-2 mb-2 align-middle'>
          <b-table :per-page='ecAnaliticoPerPage' :current-page='ecAnaliticoCurrentPage' striped bordered hover
            :fields='ecAnaliticoFields' :items='ecAnaliticoItems' responsive :busy='false' foot-clone no-footer-sorting
            foot-row-variant="secondary">

            <template #cell(selection)='data'>
              <b-form-radio v-model='selectedRow' name='selection' :value='data'></b-form-radio>
            </template>

            <template #foot(selection)="data"></template>

            <template #foot()="data">
              {{ formatCurrency(data.column) }}
            </template>

          </b-table>

        </div>
        <div class='row justify-content-between mx-2 mt-0 align-middle'>
          <div class='text-right'>
            <b-pagination :total-rows='ecAnaliticoTotalRows' :per-page='ecAnaliticoPerPage'
              v-model='ecAnaliticoCurrentPage' class='my-0' />
          </div>
          <div class='text-right'>
            <b-form-group description='Per pagina' class='mb-0'>
              <b-form-select :options='pageOptions' v-model='ecAnaliticoPerPage' />
            </b-form-group>
          </div>
        </div>
        <div class='row justify-content-end mt-5'>
          <b-button class='mr-2' @click='showModal(selectedRow.item.ID_DOCUMENTO, selectedRow.item.TIPO)'
            variant='primary' :disabled='selectedRow == null'>Dettaglio
            Movimenti</b-button>
          <b-button class='mr-2' @click='showPagatoModal(selectedRow.item.ID_DOCUMENTO)' variant='primary'
            :disabled="selectedRow == null || selectedRow.item.TIPO == 'ANT' || selectedRow.item.TIPO == 'NOT' || (selectedRow.item.IMPORTO_PAGATO + selectedRow.item.IMPORTO_STORNATO + selectedRow.item.IMPORTO_RATEIZZATO == 0)">Dettaglio
            Pagamenti</b-button>
          <b-button class='mr-2' @click='showRateModal(selectedRow.item.ID_DOCUMENTO)' variant='primary'
            :disabled="selectedRow == null || selectedRow.item.TIPO == 'ANT' || selectedRow.item.TIPO == 'NOT'">Dettaglio
            Rate</b-button>

          <b-overlay :show="busy" rounded opacity="0.6" spinner-small spinner-variant="secondary" class="d-inline-block"
            @hidden="onHidden">
            <b-button ref="button" :disabled="busy || !ecAnaliticoTotalRows" variant="secondary" @click="onDownloadEcXls">
              Esporta XLS
            </b-button>
          </b-overlay>

          <b-modal size='xl' ref='my-modal1'
            :title="`Dettaglio movimenti documento: ${selectedRow != null ? selectedRow.item.ID_DOCUMENTO : ''}`" centered
            body-class='p-3' no-close-on-backdrop>
            <loading-spinner v-if='modaleLoading' />

            <b-table v-else-if="selectedRow != null && selectedRow.item.TIPO == 'FAT' && numeroMovimentiDettaglio > 0"
              :per-page='dettaglioDocumentoFatPerPage' :current-page='dettaglioDocumentoFatCurrentPage' striped bordered
              hover :fields='dettaglioDocumentoFatFields' :items='dettaglioDocumentoFatItems' responsive :busy='false'>
            </b-table>

            <b-table v-else-if="selectedRow != null && selectedRow.item.TIPO == 'ANT' && numeroMovimentiDettaglio > 0"
              :per-page='dettaglioDocumentoAntPerPage' :current-page='dettaglioDocumentoAntCurrentPage' striped bordered
              hover :fields='dettaglioDocumentoAntFields' :items='dettaglioDocumentoAntItems' responsive :busy='false'>
            </b-table>
            <b-table v-else-if="selectedRow != null && selectedRow.item.TIPO == 'NOT' && numeroMovimentiDettaglio > 0"
              :per-page='dettaglioDocumentoNotPerPage' :current-page='dettaglioDocumentoNotCurrentPage' striped bordered
              hover :fields='dettaglioDocumentoNotFields' :items='dettaglioDocumentoNotItems' responsive :busy='false'>
            </b-table>
            <p v-else>Non sono presenti dati.</p>

            <div v-if="selectedRow != null && selectedRow.item.TIPO == 'FAT' && numeroMovimentiDettaglio > 0"
              class='row justify-content-between mx-0 mt-0 align-middle'>
              <div class='text-right'>
                <b-pagination :total-rows='dettaglioDocumentoFatTotalRows' :per-page='dettaglioDocumentoFatPerPage'
                  v-model='dettaglioDocumentoFatCurrentPage' class='my-0' />
              </div>
              <div class='text-right'>
                <b-form-group description='Per pagina' class='mb-0'>
                  <b-form-select :options='pageOptions' v-model='dettaglioDocumentoFatPerPage' />
                </b-form-group>
              </div>
            </div>
            <div v-else-if="selectedRow != null && selectedRow.item.TIPO == 'ANT' && numeroMovimentiDettaglio > 0"
              class='row justify-content-between mx-0 mt-0 align-middle'>
              <div class='text-right'>
                <b-pagination :total-rows='dettaglioDocumentoAntTotalRows' :per-page='dettaglioDocumentoAntPerPage'
                  v-model='dettaglioDocumentoAntCurrentPage' class='my-0' />
              </div>
              <div class='text-right'>
                <b-form-group description='Per pagina' class='mb-0'>
                  <b-form-select :options='pageOptions' v-model='dettaglioDocumentoAntPerPage' />
                </b-form-group>
              </div>
            </div>
            <div v-else-if="numeroMovimentiDettaglio > 0" class='row justify-content-between mx-0 mt-0 align-middle'>
              <div class='text-right'>
                <b-pagination :total-rows='dettaglioDocumentoNotTotalRows' :per-page='dettaglioDocumentoNotPerPage'
                  v-model='dettaglioDocumentoNotCurrentPage' class='my-0' />
              </div>
              <div class='text-right'>
                <b-form-group description='Per pagina' class='mb-0'>
                  <b-form-select :options='pageOptions' v-model='dettaglioDocumentoNotPerPage' />
                </b-form-group>
              </div>
            </div>

            <template slot='modal-footer'>
              <b-overlay v-if='!modaleLoading && numeroMovimentiDettaglio != 0' :show="busy1" rounded opacity="0.6"
                spinner-small spinner-variant="secondary" class="d-inline-block" @hidden="onHidden">
                <b-button ref="button" :disabled="busy1" variant="secondary"
                  @click="generaDettaglioMovimentiXls(selectedRow.item.ID_DOCUMENTO, selectedRow.item.TIPO)">
                  Esporta XLS
                </b-button>
              </b-overlay>
              <b-button variant='outline-secondary' @click='hideModal("my-modal1")'>
                Chiudi
              </b-button>
            </template>
          </b-modal>

          <b-modal size='xl' ref='my-modal2'
            :title="`Dettaglio pagamenti documento: ${selectedRow != null ? selectedRow.item.ID_DOCUMENTO : ''}`" centered
            body-class='p-3' no-close-on-backdrop>
            <loading-spinner v-if='modaleLoading' />
            <p v-else-if='numeroMovimentiDettaglio == 0'>Non sono presenti dati.</p>
            <b-table v-else-if="selectedRow != null" :per-page='dettaglioPagatoPerPage'
              :current-page='dettaglioPagatoCurrentPage' striped bordered hover :fields='dettaglioPagatoFields'
              :items='dettaglioPagatoItems' responsive :busy='false'>
            </b-table>

            <div v-if="numeroMovimentiDettaglio > 0" class='row justify-content-between mx-0 mt-0 align-middle'>
              <div class='text-right'>
                <b-pagination :total-rows='dettaglioPagatoTotalRows' :per-page='dettaglioPagatoPerPage'
                  v-model='dettaglioPagatoCurrentPage' class='my-0' />
              </div>
              <div class='text-right'>
                <b-form-group description='Per pagina' class='mb-0'>
                  <b-form-select :options='pageOptions' v-model='dettaglioPagatoPerPage' />
                </b-form-group>
              </div>
            </div>
            <template slot='modal-footer'>
              <b-overlay v-if='!modaleLoading && numeroMovimentiDettaglio != 0' :show="busy1" rounded opacity="0.6"
                spinner-small spinner-variant="secondary" class="d-inline-block" @hidden="onHidden">
                <b-button ref="button" :disabled="busy1" variant="secondary"
                  @click="generaDettaglioPagamentiXls(selectedRow.item.ID_DOCUMENTO)">
                  Esporta XLS
                </b-button>
              </b-overlay>
              <b-button variant='outline-secondary' @click='hideModal("my-modal2")'>
                Chiudi
              </b-button>
            </template>
          </b-modal>
          <b-modal size='xl' ref='my-modal3'
            :title="`Dettaglio rate emesse documento: ${selectedRow != null ? selectedRow.item.ID_DOCUMENTO : ''}`"
            centered body-class='p-3' no-close-on-backdrop>
            <loading-spinner v-if='modaleLoading' />
            <p v-else-if='numeroMovimentiDettaglio == 0'>Non sono presenti dati.</p>
            <b-table v-else-if="selectedRow != null" :per-page='dettaglioRateEmessePerPage'
              :current-page='dettaglioRateEmesseCurrentPage' striped bordered hover :fields='dettaglioRateEmesseFields'
              :items='dettaglioRateEmesseItems' responsive :busy='false'>
            </b-table>
            <div v-if="numeroMovimentiDettaglio > 0" class='row justify-content-between mx-0 mt-0 align-middle'>
              <div class='text-right'>
                <b-pagination :total-rows='dettaglioRateEmesseTotalRows' :per-page='dettaglioRateEmessePerPage'
                  v-model='dettaglioRateEmesseCurrentPage' class='my-0' />
              </div>
              <div class='text-right'>
                <b-form-group description='Per pagina' class='mb-0'>
                  <b-form-select :options='pageOptions' v-model='dettaglioRateEmessePerPage' />
                </b-form-group>
              </div>
            </div>
            <template slot='modal-footer'>
              <b-overlay v-if='!modaleLoading && numeroMovimentiDettaglio != 0' :show="busy1" rounded opacity="0.6"
                spinner-small spinner-variant="secondary" class="d-inline-block" @hidden="onHidden">
                <b-button ref="button" :disabled="busy1" variant="secondary"
                  @click="generaDettaglioRateEmesseXls(selectedRow.item.ID_DOCUMENTO)">
                  Esporta XLS
                </b-button>
              </b-overlay>
              <b-button variant='outline-secondary' @click='hideModal("my-modal3")'>
                Chiudi
              </b-button>
            </template>
          </b-modal>
        </div>
      </span>
    </div>
    <div v-else-if='$store.getters.isAuthenticated && $route.query.estrattoConto == 2'>
      <b-alert v-if="this.ecPerAnnoItems.length == 0" show variant="info" class="my-4">
        Non ci sono dati da visualizzare.
      </b-alert>
      <span v-else>
        <h4 style='float: left;'>Matricola: {{ $route.query.matricola }} - Elenco movimenti per anno</h4>
        <b-table :per-page='ecPerAnnoPerPage' :current-page='ecPerAnnoCurrentPage' striped bordered hover
          :fields='ecPerAnnoFields' :items='ecPerAnnoItems' responsive :busy='false' foot-clone no-footer-sorting
          foot-row-variant="secondary">

          <template #foot()="data">
            {{ formatCurrency(data.column) }}
          </template>

        </b-table>

        <div class='row justify-content-between mx-0 mt-0 mb-3 align-middle'>
          <div class='text-right'>
            <b-pagination :total-rows='ecPerAnnoTotalRows' :per-page='ecPerAnnoPerPage' v-model='ecPerAnnoCurrentPage'
              class='my-0' />
          </div>
          <div class='text-right'>
            <b-form-group description='Per pagina' class='mb-0'>
              <b-form-select :options='pageOptions' v-model='ecPerAnnoPerPage' />
            </b-form-group>
          </div>
        </div>
        <div class="row justify-content-end">
          <!-- <b-button @click="generaEstrattoContoPerAnnoXls()">
          Esporta XLS
        </b-button> -->
          <b-overlay :show="busy" rounded opacity="0.6" spinner-small spinner-variant="secondary" class="d-inline-block"
            @hidden="onHidden">
            <b-button ref="button" :disabled="busy || !ecPerAnnoTotalRows" variant="secondary" @click="onDownloadEcXls">
              Esporta XLS
            </b-button>
          </b-overlay>
        </div>
      </span>
    </div>
    <div v-else-if='$store.getters.isAuthenticated && $route.query.estrattoConto == 3'>
      <b-alert v-if="this.versamentiItems.length == 0" show variant="info" class="my-4">
        Non ci sono dati da visualizzare.
      </b-alert>
      <span v-else>
        <h4 style='float: left;'>Matricola: {{ $route.query.matricola }} - Elenco versamenti</h4>
        <b-table :per-page='versamentiPerPage' :current-page='versamentiCurrentPage' striped bordered hover
          :fields='versamentiFields' :items='versamentiItems' responsive :busy='false'>

          <template #cell(selection)='data'>
            <b-form-radio v-model='selectedRow' name='selection' :value='data'></b-form-radio>
          </template>
        </b-table>

        <div class='row justify-content-between mx-0 mt-0 mb-3 align-middle'>
          <div class='text-right'>
            <b-pagination :total-rows='versamentiTotalRows' :per-page='versamentiPerPage' v-model='versamentiCurrentPage'
              class='my-0' />
          </div>
          <div class='text-right'>
            <b-form-group description='Per pagina' class='mb-0'>
              <b-form-select :options='pageOptions' v-model='versamentiPerPage' />
            </b-form-group>
          </div>
        </div>
        <div class='row justify-content-end mt-5'>
          <b-button class='mr-2' @click='showVersamentoModal(selectedRow.item.ID_VERSAMENTO)' variant='primary'
            :disabled='selectedRow == null'>Dettaglio
            Versamento</b-button>
          <b-overlay :show="busy" rounded opacity="0.6" spinner-small spinner-variant="secondary" class="d-inline-block"
            @hidden="onHidden">
            <b-button ref="button" :disabled="busy || !versamentiTotalRows" variant="secondary" @click="onDownloadEcXls">
              Esporta XLS
            </b-button>
          </b-overlay>
          <b-modal size='xl' ref='my-modal4'
            :title="`Dettaglio versamento: ${selectedRow != null ? selectedRow.item.ID_VERSAMENTO : ''}`" centered
            body-class='p-3' no-close-on-backdrop>
            <loading-spinner v-if='modaleLoading' />
            <b-table v-else-if="selectedRow != null && numeroMovimentiDettaglio > 0"
              :per-page='dettaglioVersamentiPerPage' :current-page='dettaglioVersamentiCurrentPage' striped bordered hover
              :fields='dettaglioVersamentiFields' :items='dettaglioVersamentiItems' responsive :busy='false'>
            </b-table>

            <p v-else>Non sono presenti dati.</p>
            <div class='row justify-content-between mx-0 mt-0 mb-3 align-middle'>
              <div class='text-right'>
                <b-pagination :total-rows='dettaglioVersamentiTotalRows' :per-page='dettaglioVersamentiPerPage'
                  v-model='dettaglioVersamentiCurrentPage' class='my-0' />
              </div>
              <div class='text-right'>
                <b-form-group description='Per pagina' class='mb-0'>
                  <b-form-select :options='pageOptions' v-model='versamentiPerPage' />
                </b-form-group>
              </div>
            </div>
            <template slot='modal-footer'>
              <b-overlay :show="busy1" rounded opacity="0.6" spinner-small spinner-variant="secondary"
                class="d-inline-block" @hidden="onHidden">
                <b-button ref="button" :disabled="busy1 || !dettaglioVersamentiTotalRows" variant="secondary"
                  @click="generaDettaglioVersamentoXls(selectedRow.item.ID_VERSAMENTO)">
                  Esporta XLS
                </b-button>
              </b-overlay>
              <b-button variant='outline-secondary' @click='hideModal("my-modal4")'>
                Chiudi
              </b-button>
            </template>
          </b-modal>
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import LoadingSpinner from '@/components/LoadingSpinner'
import NuovaDichiarazioneModal from '@/components/NuovaDichiarazioneModal'
import axios from 'axios'

export default {
  components: {
    LoadingSpinner,
    NuovaDichiarazioneModal
  },

  data() {
    return {
      busy: false,
      busy1: false,
      totaliEcAnalitico: [],
      totaliEcPerAnno: [],
      ecAnaliticoItems: [],
      ecPerAnnoItems: [],
      versamentiItems: [],
      dettaglioDocumentoFatItems: [],
      dettaglioDocumentoAntItems: [],
      dettaglioDocumentoNotItems: [],
      dettaglioPagatoItems: [],
      dettaglioRateEmesseItems: [],
      dettaglioVersamentiItems: [],
      numeroMovimentiDettaglio: 0,
      loading: true,
      modaleLoading: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15],

      ecAnaliticoCurrentPage: 1,
      ecAnaliticoPerPage: 10,
      ecAnaliticoTotalRows: 0,

      ecPerAnnoCurrentPage: 1,
      ecPerAnnoPerPage: 10,
      ecPerAnnoTotalRows: 0,

      versamentiCurrentPage: 1,
      versamentiPerPage: 10,
      versamentiTotalRows: 0,

      dettaglioVersamentiCurrentPage: 1,
      dettaglioVersamentiPerPage: 10,
      dettaglioVersamentiTotalRows: 0,

      dettaglioDocumentoFatCurrentPage: 1,
      dettaglioDocumentoFatPerPage: 10,
      dettaglioDocumentoFatTotalRows: 0,

      dettaglioDocumentoAntCurrentPage: 1,
      dettaglioDocumentoAntPerPage: 10,
      dettaglioDocumentoAntTotalRows: 0,

      dettaglioDocumentoNotCurrentPage: 1,
      dettaglioDocumentoNotPerPage: 10,
      dettaglioDocumentoNotTotalRows: 0,

      dettaglioPagatoCurrentPage: 1,
      dettaglioPagatoPerPage: 10,
      dettaglioPagatoTotalRows: 0,

      dettaglioRateEmesseCurrentPage: 1,
      dettaglioRateEmessePerPage: 10,
      dettaglioRateEmesseTotalRows: 0,

      ecAnaliticoFields: [
        { key: 'selection', label: '', sortable: false },
        { key: 'VOCE', label: 'Voce', sortable: true },
        { key: 'bu', label: 'Codice BU', sortable: true },
        { key: 'RU', label: 'Codice RU', sortable: true },
        { key: 'TIPO_DOCUMENTO', label: 'Tipo documento', sortable: true },
        { key: 'ID_DOCUMENTO', label: 'Id documento', sortable: true },
        { key: 'DATA_DOCUMENTO', label: 'Data documento', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DATA_SCADENZA', label: 'Data scadenza', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'IMPORTO_LORDO_EMESSO', label: 'Importo lordo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_STORNATO', label: 'Stornato', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'PARTE_CORRISPETTIVI', label: 'Parte corrispettivi', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'PARTE_ONERI', label: 'Parte oneri', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'PARTE_ALTRO', label: 'Parte altro', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_PAGATO', label: 'Pagato unica soluzione', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_RATEIZZATO', label: 'Importo rimborsato', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'FATATT_IMPORTO_RATE_EMESSE', label: 'Importo rate emesse', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'FATATT_IMPORTO_RATE_PAGATE', label: 'Importo rate pagate', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'TOTALE_IMPORTO_EMESSO', label: 'Totale emesso', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'INCA_RESIDUO', label: 'Residuo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
      ],
      ecPerAnnoFields: [
        { key: 'ANNO', label: 'Anno', sortable: true },
        { key: 'bu', label: 'Codice BU', sortable: true },
        { key: 'IMPORTO_LORDO_EMESSO', label: 'Importo lordo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_STORNATO', label: 'Stornato', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'PARTE_CORRISPETTIVI', label: 'Parte corrispettivi', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'PARTE_ONERI', label: 'Parte oneri', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'PARTE_ALTRO', label: 'Parte altro', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_PAGATO', label: 'Pagato unica soluzione', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_RATEIZZATO', label: 'Importo rimborsato', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'FATATT_IMPORTO_RATE_EMESSE', label: 'Importo rate emesse', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'FATATT_IMPORTO_RATE_PAGATE', label: 'Importo rate pagate', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'TOTALE_IMPORTO_EMESSO', label: 'Totale emesso', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'INCA_RESIDUO', label: 'Importo residuo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
      ],
      versamentiFields: [
        { key: 'selection', label: '', sortable: false },
        { key: 'TIPO_VERSAMENTO', label: 'Tipo versamento', sortable: true },
        { key: 'ID_VERSAMENTO', label: 'Id versamento', sortable: true },
        { key: 'CONTO_ACCREDITO', label: 'Conto accredito', sortable: true },
        { key: 'DATA_VALUTA', label: 'Data valuta', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DATA_VERSAMENTO', label: 'Data versamento', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'IMPORTO_VERSAMENTO', label: 'Importo versamento', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_A_DEPOSITO', label: 'Importo a deposito', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_A_FATTURA', label: 'Importo a fattura', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_AD_ANTICIPO', label: 'Importo ad anticipo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
      ],
      dettaglioVersamentiFields: [
        { key: 'DATA_OPERAZIONE', label: 'Data operazione', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DATA_VALUTA', label: 'Data valuta', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'ID_MOVIMENTO', label: 'Id movimento', sortable: true },
        { key: 'RU', label: 'Codice RU', sortable: true },
        { key: 'DA', label: 'Dal', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'AL', label: 'Al', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'IMPORTO', label: 'Importo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'DESCRIZIONE_VOCE', label: 'Desc. voce', sortable: true }, //TODO VERIFICARE CAMPO CON GIANLUCA
        { key: 'ID_FATTURA', label: 'Id fattura', sortable: true },
        { key: 'DATA_SCADENZA_FATTURA', label: 'Data scadenza', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } }
      ],
      dettaglioDocumentoFatFields: [
        { key: 'DESCRIZIONE_VOCE', label: 'Tipo addebito', sortable: true },
        { key: 'ID_MOVIMENTO', label: 'Id movimento', sortable: true },
        { key: 'DAL', label: 'Dal', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'AL', label: 'Al', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'IMPORTO', label: 'Importo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_STORNATO', label: 'Storno', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'ID_NOTA_CREDITO', label: 'Nota credito', sortable: true },
      ],
      dettaglioDocumentoAntFields: [
        { key: 'DATA_VERSAMENTO', label: 'Data operazione', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DATA_VALUTA', label: 'Data valuta', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'ID_MOVIMENTO', label: 'Id movimento', sortable: true },
        { key: 'TIPO_IMPUTAZIONE', label: 'Tipo imputazione', sortable: true },
        { key: 'IMPORTO', label: 'Importo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'ID_FATTURA', label: 'Id fattura', sortable: true },
        { key: 'DATA_SCADENZA_FATTURA', label: 'Data scadenza', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DESCRIZIONE_VOCE', label: 'Tipo spesa', sortable: true }
      ],
      dettaglioDocumentoNotFields: [
        { key: 'DESCRIZIONE_VOCE', label: 'Tipo spesa', sortable: true },
        { key: 'ID_MOVIMENTO', label: 'Id movimento', sortable: true },
        { key: 'DAL', label: 'Dal', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'AL', label: 'Al', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'IMPORTO', label: 'Importo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'NOTE', label: 'Nota credito', sortable: true },
      ],
      dettaglioPagatoFields: [
        { key: 'DATA_SCADENZA_DOCUMENTO', label: 'Data scadenza', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'RU', label: 'Codice RU', sortable: true },
        { key: 'ID_VERSAMENTO', label: 'Id movimento', sortable: true },
        { key: 'DATA_VERSAMENTO', label: 'Data operazione', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DATA_VALUTA', label: 'Data valuta op.', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'TIPO_VERSAMENTO', label: 'Tipo mov.', sortable: true },
        { key: 'IMPORTO', label: 'Importo', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'DESCRIZIONE_VOCE', label: 'Tipo spesa', sortable: true },
      ],
      dettaglioRateEmesseFields: [
        { key: 'PIANO_RATEIZZAZIONE', label: 'Piano rateizzazione', sortable: true },
        { key: 'ID_RATEIZZAZIONE', label: 'Id piano', sortable: true },
        { key: 'DATA_RICONOSCIMENTO_DEBITO', label: 'Data debito', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DATA_INIZIO_RATEIZZAZIONE', label: 'Inizio piano', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'IMPORTO_RATEIZZATO', label: 'Importo rateizzato', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'NUMERO_RATE_PREVISTE', label: 'Rate previste', sortable: true },
        { key: 'NUMERO_RATA_EMESSA', label: 'Rate emesse', sortable: true },
        { key: 'IMPORTO_RATA', label: 'Importo rata', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_QUOTA_CAPITALE', label: 'Quota capitale', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : ' - ' } },
        { key: 'IMPORTO_QUOTA_INTERESSI', label: 'Quota interessi', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(0) } },
        { key: 'IMPORTO_PAGATO_RATA', label: 'Rata pagata', sortable: true, formatter: (value) => { return value ? Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(value) : Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(0) } },
      ],
      selectedRow: null,
      estrattoConto: 1
    }
  },

  async created() {
    await this.load()
  },

  methods: {

    back() {
      this.$router.push({ name: 'estratticonto' })
    },

    async load() {
      this.loading = true
      if (this.$route.query.estrattoConto == 1) {
        await this.generaEstrattoContoAnalitico();
      } else if (this.$route.query.estrattoConto == 2) {
        await this.generaEstrattoContoPerAnno();
      } else {
        await this.generaVersamenti();
      }
      this.loading = false
    },

    async generaEstrattoContoAnalitico() {
      try {
        const filters = {
          dataDal: this.$route.query.dataDal,
          dataAl: this.$route.query.dataAl,
          checked: this.$route.query.checked,
        }
        const parameters = {
          codiciRU: typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v),
          matricola: '' + this.$route.query.matricola,
          filters: filters
        }

        await this.$store.dispatch('estratticonto/estrattoContoAnalitico', parameters)
        this.ecAnaliticoItems = this.$store.state.estratticonto.estrattoContoAnalitico
        this.ecAnaliticoTotalRows = this.ecAnaliticoItems.length || 0

        await this.$store.dispatch('estratticonto/totaliEstrattoContoAnalitico', parameters)
        this.totaliEcAnalitico = this.$store.state.estratticonto.totaliEstrattoContoAnalitico.length > 0 ? this.$store.state.estratticonto.totaliEstrattoContoAnalitico[0] : {}

      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async generaEstrattoContoPerAnno() {
      try {
        const parameters = {
          codiciRU: typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v),
          matricola: '' + this.$route.query.matricola,
        }
        await this.$store.dispatch('estratticonto/estrattoContoPerAnno', parameters)
        this.ecPerAnnoItems = this.$store.state.estratticonto.estrattoContoPerAnno
        this.ecPerAnnoTotalRows = this.ecPerAnnoItems.length || 0

        await this.$store.dispatch('estratticonto/totaliEstrattoContoPerAnno', parameters)
        this.totaliEcPerAnno = this.$store.state.estratticonto.totaliEstrattoContoPerAnno.length > 0 ? this.$store.state.estratticonto.totaliEstrattoContoPerAnno[0] : {}

      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async showModal(id, tipo) {
      this.$refs['my-modal1'].show()
      this.modaleLoading = true
      await this.visualizzaDettaglioDocumento(id, tipo)
      this.modaleLoading = false
    },

    hideModal(idModal) {
      this.$refs[idModal].hide()
    },

    async visualizzaDettaglioDocumento(id, tipo) {
      try {
        const codiciRU = typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v)
        const matricola = '' + this.$route.query.matricola
        this.resetDetail()
        await this.$store.dispatch('estratticonto/dettaglioDocumentoById', { id: id, tipo: tipo, codiciRU: codiciRU, matricola: matricola })
        if (tipo == "FAT") {
          this.dettaglioDocumentoFatItems = this.$store.state.estratticonto.dettaglioDocumentoById
          this.dettaglioDocumentoFatTotalRows = this.dettaglioDocumentoFatItems.length || 0
          this.numeroMovimentiDettaglio = this.dettaglioDocumentoFatTotalRows
        } else if (tipo == "ANT") {
          this.dettaglioDocumentoAntItems = this.$store.state.estratticonto.dettaglioDocumentoById
          this.dettaglioDocumentoAntTotalRows = this.dettaglioDocumentoAntItems.length || 0
          this.numeroMovimentiDettaglio = this.dettaglioDocumentoAntTotalRows
        } else {
          this.dettaglioDocumentoNotItems = this.$store.state.estratticonto.dettaglioDocumentoById
          this.dettaglioDocumentoNotTotalRows = this.dettaglioDocumentoNotItems.length || 0
          this.numeroMovimentiDettaglio = this.dettaglioDocumentoNotTotalRows
        }
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    resetDetail() {
      this.dettaglioDocumentoFatItems = null
      this.dettaglioDocumentoFatTotalRows = 0
      this.dettaglioDocumentoAntItems = null
      this.dettaglioDocumentoAntTotalRows = 0
      this.dettaglioDocumentoNotItems = null
      this.dettaglioDocumentoNotTotalRows = 0

      this.dettaglioPagatoItems = null
      this.dettaglioPagatoTotalRows = 0
      this.dettaglioRateEmesseItems = null
      this.dettaglioRateEmesseTotalRows = 0

      this.numeroMovimentiDettaglio = 0
    },

    async showVersamentoModal(id) {
      this.$refs['my-modal4'].show()
      this.modaleLoading = true
      await this.visualizzaDettaglioVersamenti(id)
      this.modaleLoading = false
    },

    async showPagatoModal(id) {
      this.$refs['my-modal2'].show()
      this.modaleLoading = true
      await this.visualizzaDettaglioPagato(id)
      this.modaleLoading = false
    },

    async showRateModal(id) {
      this.$refs['my-modal3'].show()
      this.modaleLoading = true
      await this.visualizzaRateEmesse(id)
      this.modaleLoading = false
    },

    async visualizzaDettaglioPagato(id) {
      try {
        const codiciRU = typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v)
        const matricola = '' + this.$route.query.matricola
        this.resetDetail()

        await this.$store.dispatch('estratticonto/dettaglioPagato', { id, codiciRU: codiciRU, matricola: matricola })
        this.dettaglioPagatoItems = this.$store.state.estratticonto.dettaglioPagato
        this.dettaglioPagatoTotalRows = this.dettaglioPagatoItems.length || 0
        this.numeroMovimentiDettaglio = this.dettaglioPagatoTotalRows
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async visualizzaRateEmesse(id) {
      try {
        const codiciRU = typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v)
        const matricola = '' + this.$route.query.matricola
        this.resetDetail()

        await this.$store.dispatch('estratticonto/dettaglioRateEmesse', { id, codiciRU: codiciRU, matricola: matricola })
        this.dettaglioRateEmesseItems = this.$store.state.estratticonto.dettaglioRateEmesse
        this.dettaglioRateEmesseTotalRows = this.dettaglioRateEmesseItems.length || 0
        this.numeroMovimentiDettaglio = this.dettaglioRateEmesseTotalRows
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async generaVersamenti() {
      try {
        const filters = {
          dataDal: this.$route.query.dataDal,
          dataAl: this.$route.query.dataAl,
        }
        const parameters = {
          codiciRU: typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v),
          matricola: '' + this.$route.query.matricola,
          filters: filters
        }
        await this.$store.dispatch('estratticonto/visualizzaVersamenti', parameters)
        this.versamentiItems = this.$store.state.estratticonto.visualizzaVersamenti
        this.versamentiTotalRows = this.versamentiItems.length || 0
        this.numeroMovimentiDettaglio = this.versamentiTotalRows
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async visualizzaDettaglioVersamenti(id) {
      try {
        const codiciRU = typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v)
        const matricola = '' + this.$route.query.matricola
        await this.$store.dispatch('estratticonto/getDettaglioVersamenti', { id, codiciRU: codiciRU, matricola: matricola })

        this.dettaglioVersamentiItems = this.$store.state.estratticonto.dettaglioVersamenti
        this.dettaglioVersamentiTotalRows = this.dettaglioVersamentiItems.length || 0
        this.numeroMovimentiDettaglio = this.dettaglioVersamentiTotalRows
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async generaEstrattoContoPerAnnoXls() {
      try {
        const parameters = {
          codiciRU: typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v),
          matricola: '' + this.$route.query.matricola,
        }
        await axios.post('/api/estratticonto/estratto_conto_per_anno_xls', { parameters },
          { responsetype: 'blob' }).then((response) => {
            const link = document.createElement('a')
            link.href = response.data.data
            link.download = response.data.fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link);
          });
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async generaEstrattoContoAnaliticoXls() {
      try {
        const filters = {
          dataDal: this.$route.query.dataDal,
          dataAl: this.$route.query.dataAl,
          checked: this.$route.query.checked,
        }
        const parameters = {
          codiciRU: typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v),
          matricola: '' + this.$route.query.matricola,
          filters: filters
        }
        await axios.post('/api/estratticonto/estratto_conto_analitico_xls', {
          parameters
        }, {
          responsetype: 'blob'
        }).then((response) => {
          const link = document.createElement('a')
          link.href = response.data.data
          link.download = response.data.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link);
        });
      } catch (error) {
        this.$ui.showError(err)
      }
    },

    async generaDettaglioMovimentiXls(id, tipo) {
      this.busy1 = true
      try {
        await axios.get(`/api/estratticonto/${id}/dettaglio_documento_xls`, { params: { tipo: tipo } }, {
          responsetype: 'blob'
        }).then((response) => {
          const link = document.createElement('a')
          link.href = response.data.data
          link.download = response.data.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link);
        });
      } catch (error) {
        this.$ui.showError(err)
      }
      this.busy1 = false
    },

    async generaDettaglioPagamentiXls(id) {
      this.busy1 = true
      try {
        await axios.get(`/api/estratticonto/${id}/dettaglio_pagato_xls`, {
          id
        }, {
          responsetype: 'blob'
        }).then((response) => {
          const link = document.createElement('a')
          link.href = response.data.data
          link.download = response.data.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link);
        })
      } catch (error) {
        this.$ui.showError(err)
      }
      this.busy1 = false
    },

    async generaDettaglioRateEmesseXls(id) {
      this.busy1 = true
      try {
        await axios.get(`/api/estratticonto/${id}/dettaglio_rate_emesse_xls`, {
          id
        }, {
          responsetype: 'blob'
        }).then((response) => {
          const link = document.createElement('a')
          link.href = response.data.data
          link.download = response.data.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link);
        });
      } catch (error) {
        this.$ui.showError(err)
      }
      this.busy1 = false
    },

    async generaVersamentiXls() {
      try {
        const filters = {
          dataDal: this.$route.query.dataDal,
          dataAl: this.$route.query.dataAl,
        }
        const parameters = {
          codiciRU: typeof this.$route.query.codiciRU == 'string' ? this.$route.query.codiciRU : this.$route.query.codiciRU.map((v) => '' + v),
          matricola: '' + this.$route.query.matricola,
          filters: filters
        }
        await axios.post('/api/estratticonto/visualizza_versamenti_xls', {
          parameters
        }, {
          responsetype: 'blob'
        }).then((response) => {
          const link = document.createElement('a')
          link.href = response.data.data
          link.download = response.data.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link);
        });
      } catch (error) {
        this.$ui.showError(err)
      }
    },

    async generaDettaglioVersamentoXls(id) {
      this.busy1 = true
      try {
        await axios.get(`/api/estratticonto/${id}/dettaglio_versamento_xls`, {
          id
        }, {
          responsetype: 'blob'
        }).then((response) => {
          const link = document.createElement('a')
          link.href = response.data.data
          link.download = response.data.fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link);
        });
      } catch (error) {
        this.$ui.showError(err)
      }
      this.busy1 = false
    },

    dataFilenameXls() {
      return moment(new Date(), moment.ISO_8601).format('YYYY-MM-DD');
    },

    onHidden() {
      // Return focus to the button once hidden
      this.$refs.button.focus()
    },

    async onDownloadEcXls() {
      this.busy = true
      if (this.$route.query.estrattoConto == 1) {
        await this.generaEstrattoContoAnaliticoXls();
      } else if (this.$route.query.estrattoConto == 2) {
        await this.generaEstrattoContoPerAnnoXls();
      } else {
        await this.generaVersamentiXls();
      }
      this.busy = false
    },

    formatCurrency(value) {
      if (this.totaliEcAnalitico && this.totaliEcAnalitico[value] != undefined) {
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
        }).format(this.totaliEcAnalitico[value]);
      } else if (this.totaliEcPerAnno && this.totaliEcPerAnno[value] != undefined) {
        return new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2,
        }).format(this.totaliEcPerAnno[value]);
      }
    },
  },

  computed: {
    disabled() {
      return this.estrattoConto != 1
    },
  }
}
</script>

<style lang="scss">
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 100rem;
  }
}
</style>
